/**
 * @author Ivan Toth.
 * gpp - autocheck tlogs table
 */
var INC_COMMENTS = {
    solutionId: 'pnEngagement',
    salesCheck: 'pnSalesInc',
    focusCheck: 'pnFocus',
    growthCheck: 'pnGrowth',
    ctlCheck: 'pnCtl'
};
//TODO - do a common code
//NOTE: failed InsentiveRule can be RED or YELLOW
var IconColor;
(function (IconColor) {
    IconColor[IconColor["GREEN"] = 'green'] = "GREEN";
    IconColor[IconColor["ORANGE"] = 'orange'] = "ORANGE";
    IconColor[IconColor["PINK"] = 'pink'] = "PINK";
    IconColor[IconColor["RED"] = 'red'] = "RED";
})(IconColor || (IconColor = {}));
var isIncentive = function (ruleModuleId) {
    return ['salesCheck', 'solutionId', 'focusCheck', 'growthCheck', 'ctlCheck'].indexOf(ruleModuleId) !== -1;
};
var countInsentiveRules = function (pnRiles) {
    return Array.isArray(pnRiles) ? pnRiles.filter(isIncentive).length : 0;
};
var hasAllIncentivesFailed = function (pnRiles) {
    var incRulesLen = countInsentiveRules(pnRiles.map(function (it) { return it.model; }));
    return incRulesLen > 0 && pnRiles.filter(function (it) { return isIncentive(it.model) && it.iconColor === IconColor.GREEN; }).length === 0;
};
var hasNonIncentiveRuleFailed = function (pnRiles) {
    return pnRiles.filter(function (it) { return !isIncentive(it.model) && it.iconColor === IconColor.RED; }).length > 0;
};
var hasAnyValidIncentiveResult = function (pnItem) {
    var pnItemResult = pnItem.result;
    return !pnItemResult ? false
        : Object.keys(pnItemResult)
            .filter(function (k) { return isIncentive(k) && (pnItemResult[k] === true || (pnItemResult[k] && pnItemResult[k].result === true)); }).length > 0;
};
var isIncResolved = function (rule, pnObj) {
    var incComment = INC_COMMENTS[rule];
    if (incComment) {
        return pnObj.result[rule] === false && pnObj.comments[incComment];
    }
    else {
        return false;
    }
};
var PENDING_BILLINGS_STATUS = 'Pending Billing Orders';
var DetailSOEvalController = (function () {
    function DetailSOEvalController(topic, $stateParams, settings, env, socket, $scope, Dialog, $state, $filter, moment) {
        var _this = this;
        this.topic = topic;
        this.$stateParams = $stateParams;
        this.settings = settings;
        this.env = env;
        this.socket = socket;
        this.$scope = $scope;
        this.Dialog = Dialog;
        this.$state = $state;
        this.$filter = $filter;
        this.moment = moment;
        this.pnsRules = [];
        this.pnsComments = [];
        this.orderRules = [];
        this.isSaasValid = false;
        this.orderData = {};
        this.APPROVED_ARR = ['Approved', 'Not Approved'];
        this.pnsGrowthComments = [];
        this.pnsSalesIncComments = [];
        this.pnsEngagementComments = [];
        this.pnsFocusComments = [];
        this.pnsCtlComments = {};
        this.orderRulesNames = ['ceidMatch', 'eligibilityStatus', 'endUserMatch', 'cntrySOMatch', 'distributionChannelMatch', 'dateSOMatch',
            'sodVSsvid', 'saasPaymentRange', 'isThresholdValid', 'prefDistMatch', 'coverageSaaS', 'isDirect', 'saasNotMixed', 'applicability', 'cmrCheck', 'goeReview'];
        this.OPP_VERSION_3 = 3;
        this.OPP_VERSION_4 = 4;
        this.OPP_VERSION_5 = 5;
        this.isUpdating = false;
        this.rowIdArr = [];
        this.brandfamArr = [];
        this.solutionIdMap = new Map();
        this.getNewUIInfo = {
            uiVersion: _.get(this.topic.checksData, 'uiVersion', 1)
        };
        this.socket.forward('sap.validation.reval.done', this.$scope);
        this.$scope.$on('socket:sap.validation.reval.done', function (event, data) {
            _this.isUpdating = false;
        });
        this.socket.forward('detail.sap.reset.comments', this.$scope);
        this.$scope.$on('socket:detail.sap.reset.comments', function (event, data) {
            // Remove old objects to unlock comments
            data.topic.sap.forEach(function (e) { return delete e.comments.pnOverall; });
            data.topic.sap.forEach(function (e) { return delete e.comments.pnAutofail; });
            for (var i = 0; i < _this.pnsRules.length; i++) {
                _this.checkIfPnFails(i);
            }
            // Filter out only those rules which need to fail
            Object.filter = function (obj, predicate) {
                return Object.keys(obj)
                    .filter(function (key) { return predicate(obj[key]); })
                    .reduce(function (res, key) { return (res[key] = obj[key], res); }, {});
            };
            var filteredRules = Object.filter(_this.orderData.comments, function (rule) { return rule.isFinal; });
            // Fail this rules to provide override
            Object.getOwnPropertyNames(filteredRules).forEach(function (key) { return filteredRules[key].isFinal = false; });
            // Save new 'sap' object
            var obj = {
                data: (_a = {},
                    _a['sap'] = {
                        add: true,
                        data: data.topic.sap
                    },
                    _a
                ),
                id: _this.topic.topic._id,
                isChargeAgreement: _this.topic.topic.isChargeAgreement || false,
                type: ['sap']
            };
            _this.topic.updateServerTopic('couchUpdate', obj, true);
            _this.topic.topic.sap = data.topic.sap;
            _this.setEverything();
            _this.isUpdating = false;
            var _a;
        });
        this.socket.forward('detail.sap.revalidation', this.$scope);
        this.$scope.$on('socket:detail.sap.revalidation', function (event, data) {
            _this.isUpdating = false;
            if (typeof data.topic !== 'undefined' && typeof data.topic.calculation !== 'undefined'
                && typeof data.topic.calculation.children !== 'undefined' && data.topic.calculation.children.length > 0) {
                // open up the Calcs and Payment tab
                for (var i = 0; i < _this.topic.tabs.list.length; i++) {
                    if (_this.topic.tabs.list[i].name === 'detail.payment') {
                        _this.topic.tabs.list[i].editable = true;
                        _this.topic.tabs.list[i].visible = true;
                        break;
                    }
                }
                _this.topic.setActiveTab('payment');
                // Go to calcs/payments tab
                _this.$state.go('detail.payment', $stateParams);
            }
        });
        this.socket.forward('sap.validation.reval.done', this.$scope);
        this.$scope.$on('socket:sap.validation.reval.done', function (event, data) {
            _this.topic.updateTopic({ sap: data.sap }, false, []);
            var pushMessages = {
                msgLines: ['Order has been reevaluated']
            };
            _this.Dialog.showOnlyMessage(pushMessages);
        });
        this.socket.forward('validation.updateStatus', this.$scope);
        this.$scope.$on('socket:validation.updateStatus', function (event, data) {
            if ((typeof data !== 'undefined' && data.isChargeAgreement) || _this.topic.topic.isChargeAgreement) {
                _this.changeCAStatus();
            }
        });
        this.socket.forward('ods.validation.update', this.$scope);
        this.$scope.$on('socket:ods.validation.update', function (event, data) {
            _this.topic.topic.sap = data.sap;
            _this.setEverything();
        });
    }
    DetailSOEvalController.prototype.setEverything = function () {
        var _this = this;
        if (this.topic.topic.sap) {
            this.setOrderData();
            this.setOrderRules();
            this.setPnsRules(function () { return _this.checkPnRules(); });
        }
    };
    DetailSOEvalController.prototype.changeCAStatus = function () {
        this.isSaasValid = true;
        //DMT-5070 : PENDING_BILLINGS_STATUS is not required to be set from the code logic
        /*if (this.topic.temp_ext.sub_status !== PENDING_BILLINGS_STATUS) {
            this.topic.temp_ext.sub_status = PENDING_BILLINGS_STATUS;
            this.topic.sendForUpdate(['status'], '', 'Sub-Status changed to ' + PENDING_BILLINGS_STATUS, false);
        }*/
    };
    DetailSOEvalController.prototype.$onInit = function () {
        var _this = this;
        // fill the brand family array to show which solution IDs are being compared
        this.setBrandArray();
        //if (this.topic.topic.sap) {
        //this.checkSaas();
        this.setEverything();
        //}
        var sap = this.topic.topic.sap;
        // should only be applicable for oppty that the SAP service didn't fill for PPS
        if (typeof sap !== 'undefined') {
            sap.forEach(function (pn, index) {
                _this.pnsComments.push('');
            });
        }
    };
    DetailSOEvalController.prototype.getCustomerDesignation = function (data) {
        var customerDesignationODS = data.customerSegmentCode || data.TranIBMCustSegmnttnCodeDscr;
        var CustomerDesignationMap = {
            'bp': 'BP-Led',
            'bp-led': 'BP-Led',
            'co': 'Co-Led',
            'co-led': 'Co-Led',
            'ibm': 'IBM-Led',
            'ibm-led': 'IBM-Led',
            'unas': undefined,
            'unkn': undefined
        };
        if (customerDesignationODS && CustomerDesignationMap.hasOwnProperty(customerDesignationODS.toLocaleLowerCase())) {
            customerDesignationODS = CustomerDesignationMap[customerDesignationODS.toLocaleLowerCase()];
        }
        else {
            customerDesignationODS = undefined;
        }
        return (this.topic.topic.customerDesignation && customerDesignationODS) || (!this.topic.topic.customerDesignation && customerDesignationODS) ? customerDesignationODS : 'N/A';
    };
    DetailSOEvalController.prototype.save = function (key, rule) {
        var _this = this;
        var items = {
            addCancel: true,
            cancelMessage: 'Fail',
            dialogName: 'Manual Validation Rule Decision',
            message: 'Please confirm the final Validation Rule status, or click Cancel to quit:',
            okMessage: 'Pass'
        };
        this.Dialog.YesNoForm('', items, 'yes-no.html').then(function (dResult) {
            if (dResult.confirm) {
                _this.orderData.comments[rule].isFinal = true;
                _this.orderData.comments[rule].passFlag = true;
            }
            else if (!dResult.confirm) {
                _this.orderData.comments[rule].isFinal = true;
                _this.orderData.comments[rule].passFlag = false;
            }
            _this.topic.topic.sap[0].comments[rule] = _this.orderData.comments[rule];
            _this.uploadResults(key, rule, _this.orderData.comments[rule]);
            return;
        });
    };
    DetailSOEvalController.prototype.checkSaas = function () {
        // if entry has a SA attached and  all validation rules pass, then change status to Pending Billing Orders
        if ((this.topic.topic.complete.statusComplete['4'] || this.topic.topic.complete['sap'] &&
            this.topic.topic.complete.errorsArray['sap'].length === 0)
            && this.topic.topic.isChargeAgreement
            && !(this.topic.topic.calculation)) {
            this.isSaasValid = true;
        }
    };
    DetailSOEvalController.prototype.isValueDisplayed = function (rule, pn) {
        return rule.model !== 'focusCheck' || rule.model !== 'growthCheck' ||
            (rule.model === 'focusCheck' && (pn.result.focusCheck || pn.comments.pnFocus));
    };
    DetailSOEvalController.prototype.savePn = function (key, pn, text) {
        var _this = this;
        var items = {
            addCancel: true,
            cancelMessage: 'Fail',
            dialogName: 'Manual Validation Rule Decision',
            message: 'Please confirm the final Validation Rule status, or click Cancel to quit:',
            okMessage: 'Pass'
        };
        this.Dialog.YesNoForm('', items, 'yes-no.html').then(function (dResult) {
            if (dResult.confirm) {
                pn.comments.pnOverall = {
                    isFinal: true,
                    passFlag: true,
                    text: text
                };
                pn.comments.pnFocus = {
                    isFinal: true,
                    passFlag: true,
                    text: _this.pnsFocusComments[key]
                };
                pn.comments.pnEngagement = {
                    isFinal: true,
                    passFlag: true,
                    text: _this.pnsEngagementComments[key]
                };
                pn.comments.pnCtl = {
                    isFinal: true,
                    passFlag: true,
                    text: _this.pnsCtlComments[key]
                };
                pn.comments.pnGrowth = {
                    isFinal: true,
                    passFlag: true,
                    text: _this.pnsGrowthComments[key]
                };
                pn.comments.pnSalesInc = {
                    isFinal: true,
                    passFlag: true,
                    text: _this.pnsSalesIncComments[key]
                };
                pn.comments.pnIncentiveStatus = {
                    isFinal: true,
                    passFlag: true
                };
            }
            else if (!dResult.confirm) {
                pn.comments.pnOverall = {
                    isFinal: true,
                    passFlag: false,
                    text: text
                };
                pn.comments.pnFocus = {
                    isFinal: true,
                    passFlag: false,
                    text: _this.pnsFocusComments[key]
                };
                pn.comments.pnCtl = {
                    isFinal: true,
                    passFlag: false,
                    text: _this.pnsCtlComments[key]
                };
                pn.comments.pnEngagement = {
                    isFinal: true,
                    passFlag: false,
                    text: _this.pnsEngagementComments[key]
                };
                pn.comments.pnGrowth = {
                    isFinal: true,
                    passFlag: false,
                    text: _this.pnsGrowthComments[key]
                };
                pn.comments.pnSalesInc = {
                    isFinal: true,
                    passFlag: false,
                    text: _this.pnsSalesIncComments[key]
                };
                pn.comments.pnIncentiveStatus = {
                    isFinal: true,
                    passFlag: false,
                    text: 'failed manually'
                };
            }
            _this.uploadResults(0, 'pnOverall', { text: text });
            _this.setEverything();
            //this.setPnsRules(() => this.checkPnRules());
            return;
        });
    };
    DetailSOEvalController.prototype.failPart = function (event, index, part) {
        var _this = this;
        this.Dialog.updateValidForm(event, {}, 'auto-fail-dialog.html').then(function (dResult) {
            if (_.isUndefined(dResult)) {
                return;
            }
            var NOT_APPROVED = 'Not Approved';
            var APPROVED = 'Approved';
            var pnId = _.get(part, 'data.itemList[0].pn');
            // If so.data element in question AND has itemList and result
            if (!_.isUndefined(pnId) && !_.isUndefined(part.result) && !_.isUndefined(part.comments) && Array.isArray(_this.pnsRules[index])) {
                _this.pnsRules[index]
                    .map(function (el) { return el.model; })
                    .forEach(function (rule) {
                    part.result[rule] = false;
                    part.comments[rule] = {
                        isFinal: true,
                        passFlag: false,
                        text: dResult.afBundle.comment
                    };
                });
                part.comments.pnAutofail = {
                    isFinal: true,
                    passFlag: false,
                    text: dResult.afBundle.comment
                };
                //incentives
                part.comments.pnFocus = {
                    isFinal: true,
                    passFlag: false,
                    text: _this.pnsFocusComments[pnId] || NOT_APPROVED
                };
                part.comments.pnCtl = {
                    isFinal: true,
                    passFlag: false,
                    text: _this.pnsCtlComments[pnId] || NOT_APPROVED
                };
                part.comments.pnEngagement = {
                    isFinal: true,
                    passFlag: false,
                    text: _this.pnsEngagementComments[pnId] || NOT_APPROVED
                };
                part.comments.pnGrowth = {
                    isFinal: true,
                    passFlag: false,
                    text: _this.pnsGrowthComments[pnId] || NOT_APPROVED
                };
                part.comments.pnSalesInc = {
                    isFinal: true,
                    passFlag: false,
                    text: _this.pnsSalesIncComments[pnId] || NOT_APPROVED
                };
                var isPnIncentiveStatusPassed = _this.pnsFocusComments[pnId] === APPROVED
                    || _this.pnsCtlComments[pnId] === APPROVED
                    || _this.pnsEngagementComments[pnId] === APPROVED
                    || _this.pnsGrowthComments[pnId] === APPROVED
                    || _this.pnsSalesIncComments[pnId] === APPROVED;
                part.comments.pnIncentiveStatus = {
                    isFinal: true,
                    passFlag: isPnIncentiveStatusPassed
                };
            }
            var oneComment = { text: "All Errored Valdation Rules for Part Auto-Failed : " + dResult.afBundle.comment };
            _this.uploadResults(index, 'pnAutofail', oneComment);
            _this.setPnsRules(function () { return _this.checkPnRules(); });
        });
    };
    DetailSOEvalController.prototype.failSO = function (event) {
        var _this = this;
        this.Dialog.updateValidForm(event, {}, 'auto-fail-dialog.html').then(function (dResult) {
            if (!angular.isUndefined(dResult)) {
                _this.orderData.pns.forEach(function (pn) {
                    _this.orderRules.map(function (el) { return el.model; }).forEach(function (rule) {
                        pn.result[rule] = false;
                        pn.comments[rule] = {
                            isFinal: true,
                            passFlag: false,
                            text: dResult.afBundle.comment
                        };
                        _this.orderData.result[rule] = false;
                    });
                    pn.comments.soAutofail = {
                        isFinal: true,
                        passFlag: false,
                        text: dResult.afBundle.comment
                    };
                });
                var oneComment = { text: "All Errored Valdation Rules for Order Auto-Failed : " + dResult.afBundle.comment };
                _this.uploadResults(0, 'soAutofail', oneComment);
                _this.checkPnRules();
            }
        });
    };
    DetailSOEvalController.prototype.uploadResults = function (key, prop, oneComment) {
        this.isUpdating = true;
        var whereChange = this.topic.topic.sap[key].data.soNumber + "-" + this.topic.topic.sap[key].data.itemList[0].pn + ", " + prop;
        var sapObj = JSON.parse(JSON.stringify(this.topic.topic.sap));
        for (var i = 0; i < sapObj.length; i++) {
            delete sapObj[i].$$hashKey;
        }
        var data = {
            data: (_a = {},
                _a['comments.validation'] = {
                    data: [{
                            comment: whereChange + ": " + oneComment.text,
                            user: this.env.user.email
                        }],
                    push: true
                },
                _a['sap'] = {
                    add: true,
                    data: sapObj
                },
                _a
            ),
            id: this.topic.topic._id,
            isChargeAgreement: this.topic.topic.isChargeAgreement || false,
            type: ['comments', 'sap']
        };
        this.topic.updateServerTopic('couchUpdate', data, true);
        this.checkSaas();
        this.isUpdating = false;
        var _a;
    };
    DetailSOEvalController.prototype.retrigisOrValCheck = function (e) {
        var _this = this;
        this.topic.topic.sap.forEach(function (pn) {
            if (pn.data.itemList[0].curCode.trim() === _this.topic.topic.gpp_valid[0].crncy.trim()) {
                pn.result.isSameCur = true;
            }
        });
        var whereChange = 'Validity rechecked';
        var sapObj = JSON.parse(JSON.stringify(this.topic.topic.sap));
        var data = {
            data: (_a = {},
                _a['comments.validation'] = {
                    data: [{
                            comment: whereChange,
                            user: this.env.user.email
                        }],
                    push: true
                },
                _a['sap'] = {
                    add: true,
                    data: sapObj
                },
                _a
            ),
            id: this.topic.topic._id,
            isChargeAgreement: this.topic.topic.isChargeAgreement || false,
            type: ['comments', 'sap']
        };
        this.topic.updateServerTopic('couchUpdate', data, true);
        var _a;
    };
    /**
     * Function to trigger the Calculation stage
     * @param event Angular Event
     */
    DetailSOEvalController.prototype.reEvaluate = function (event) {
        var _this = this;
        var validCount = this.topic.topic.sap.length; // Count the number of parts that are 100% valid...assume they all are
        var allValid = true;
        // Work out if any of the parts are bad....
        this.topic.topic.sap.forEach(function (pn, index) {
            if (!_this.isPnPassed(pn, index)) {
                validCount--;
                allValid = false;
                pn.result.isWholeOpptyValid = false;
            }
            else {
                pn.result.isWholeOpptyValid = true;
            }
        });
        // Bundle for the pop-up
        var items = {
            calcBundle: {
                topic: this.topic.topic,
                valid: validCount
            }
        };
        // Prompt user
        this.Dialog.openDialog(event, items, '', 'reval-confirmation.html', '').then(function (dResult) {
            if (dResult.confirm) {
                _this.isUpdating = true;
                _this.socket.emit('module', {
                    module: {
                        application: 'dmt',
                        bID: _this.topic.topicBrowserID,
                        data: {
                            docId: _this.topic.topic._id,
                            email: _this.env.user.email,
                            errorReset: allValid,
                            oppVersion: _this.topic.topic.version,
                            sap: _this.topic.topic.sap
                        },
                        email: _this.env.user.email,
                        function: 'triggerCalculationClient',
                        className: 'CalculationGate',
                        script: '/detail/payment/calculationGate',
                        user: _this.env.user
                    }
                });
            }
            return;
        });
    };
    DetailSOEvalController.prototype.unlockComments = function () {
        this.isUpdating = true;
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                docId: this.topic.topic._id,
                email: this.env.user.email,
                function: 'unlockComments',
                script: '/validation/validationTables',
                token: this.env.user.token
            }
        });
    };
    DetailSOEvalController.prototype.formatDate = function (date) {
        if (/\d{4}-\d{2}-\d{2}/.test(date)) {
            return this.moment(date, 'YYYY-MM-DD').format('YYYY-MM-DD');
        }
        else if (/\d{2}\/\d{2}\/\d{4}/.test(date)) {
            return this.moment(date, 'MM-DD-YYYY').format('YYYY-MM-DD');
        }
        else if (/\d{2}.\d{2}.\d{4}/.test(date)) {
            return this.moment(date, 'DD-MM-YYYY').format('YYYY-MM-DD');
        }
        else if (/\d{4}-\d{2}-\d{2}T[\S]+/.test(date)) {
            return this.moment(date, 'YYYY-MM-DD HH:mm Z').format('YYYY-MM-DD');
        }
        else if (/\d{8}/.test(date)) {
            return this.moment(date, 'YYYYMMDD').format('YYYY-MM-DD');
        }
        else {
            var dateParsed = this.moment(date);
            if (dateParsed.isValid()) {
                return dateParsed.format('YYYY-MM-DD');
            }
            else {
                console.error("So date in a wrong format! " + date);
                return 'Invalid Date';
            }
        }
    };
    DetailSOEvalController.prototype.setOrderData = function () {
        var order = this.topic.topic.sap[0];
        if (!order) {
            return;
        }
        this.orderData.soNumber = order.data.soNumber;
        this.orderData.pns = this.topic.topic.sap;
        this.orderData.result = this.setOrderResult(this.orderData.pns);
        this.orderData.bpCEID = order.data.itemList[0].bpCEID;
        this.orderData.comparedSviStat = order.data.comparedSviStat;
        this.orderData.endUserName = order.data.endUserName;
        this.orderData.bpNumber = order.data.bpNumber;
        this.orderData.t2Number = order.data.t2Number;
        this.orderData.LOB = order.data.LOB;
        this.orderData.t2cty = order.data.t2cty;
        this.orderData.chargeAgreementStartDate = this.isMdlTypeCodeExist(this.topic.topic.sap)
            ? this.formatDate(order.data.itemList[0].chargeAgreementStartDate)
            : this.formatDate(order.data.soDate);
        this.orderData.prefDist = order.data.prefDist;
        this.orderData.cnum = order.data.cnum;
        this.orderData.comments = order.comments;
        this.orderData.isu = order.data.isu;
        this.orderData.curCode = order.data.itemList[0].curCode;
        this.orderData.firstItem = order.data.itemList[0];
        this.orderData.chanCode = order.data.chanCode;
        this.orderData.mdlTypeCode = order.data.mdlTypeCode;
        // foundRnA was replaced with isAssist, but support old oppties
        this.orderData.isAssist = this.topic.topic.isAssist !== undefined ? this.topic.topic.isAssist : order.data.foundRnA;
        this.orderData.coverageTerm = order.data.itemList[0].coverageTerm;
        this.orderData.totalRevenue = order.data.totalRevenue;
        this.orderData.invoiceNo = Array.from(new Set(this.topic.topic.sap.map(function (el) { return el.data.invoiceNo; })));
        this.orderData.resellerBp = this.orderData.bpCEID && this.topic.topic.bp_cei && this.topic.topic.bp_cei === this.orderData.bpCEID ? 'Yes' : 'No';
    };
    DetailSOEvalController.prototype.getLicenseTypeName = function (mdlTypeCode) {
        return Array.isArray(this.topic.topic.licenseTypes)
            && this.topic.topic.licenseTypes
                .filter(function (it) { return it && it.type === mdlTypeCode; })
                .map(function (it) { return it.name; })
                .pop()
            || mdlTypeCode;
    };
    DetailSOEvalController.prototype.isMdlTypeCodeExist = function (sap) {
        var types = ['SS', 'ML', 'SL'];
        for (var _i = 0, sap_1 = sap; _i < sap_1.length; _i++) {
            var el = sap_1[_i];
            return types.includes(el.data.mdlTypeCode);
        }
    };
    /**
     * Function to define all the SOV Rules... each should be a IvRule object containing a:
     * n: rule number
     * title: rule name
     * model: the angular model name
     * infoOnly: this is optional and most won't have the value - if it's set it means that
     * if the rule fails, the user will not have to enter a reason to pass it
     */
    DetailSOEvalController.prototype.setOrderRules = function () {
        var _this = this;
        var rules = [];
        if (_.get(this, "topic.topic.sales_assist.type", 'CVR Sales Assist') !== 'CVR Sales Assist') {
            rules.push({ n: 1, title: 'SO CEID vs Opportunity CEID', model: 'ceidMatch', value: this.orderData.bpCEID + " vs " + this.topic.topic.bp_cei });
        }
        //TODO - STUB fix - should be a better solution
        if (!this.orderData.result) {
            this.orderData.result = {};
        }
        var gpp_valid = this.topic.topic.gpp_valid[0] || {};
        var eligbilityStatus;
        if (this.orderData.result.eligibilityStatus && this.orderData.comparedSviStat === undefined) {
            eligbilityStatus = "Yes";
        }
        else if (!this.orderData.result.eligibilityStatus && this.orderData.comparedSviStat === undefined) {
            eligbilityStatus = "No";
        }
        else if (this.orderData.comparedSviStat !== undefined) {
            eligbilityStatus = "Used status: " + this.orderData.comparedSviStat;
        }
        rules.push({ n: 2, title: 'Is Eligibility Status Found in Validation Tables', model: 'eligibilityStatus', value: eligbilityStatus });
        rules.push({
            n: 3, title: 'BP vs End User', model: 'endUserMatch',
            value: this.orderData.t2Number + " vs " + (this.orderData.LOB === 'VP' || this.orderData.LOB === 'SP' ? this.orderData.endUserName : this.orderData.bpNumber)
        });
        rules.push({ n: 4, title: 'Country Eligibility', model: 'cntrySOMatch', value: "" + this.orderData.t2cty });
        rules.push({ n: 5, title: 'Distribution Channel', model: 'distributionChannelMatch', value: "" + this.orderData.chanCode });
        rules.push({
            n: 6, title: 'Sales Order vs Expiration Date', model: 'dateSOMatch',
            value: this.orderData.chargeAgreementStartDate + " vs " + this.moment(Number(gpp_valid.sviexpdate)).format('YYYY-MM-DD')
        });
        rules.push({
            n: 7, title: 'Is the SO Date after the Submit Date', model: 'sodVSsvid',
            value: this.orderData.chargeAgreementStartDate + " vs " + this.moment(Number(gpp_valid.svisubmitdate)).format('YYYY-MM-DD')
        });
        var saasPaymentRange;
        if (this.orderData.mdlTypeCode !== 'SS' && !this.orderData.isAssist) {
            saasPaymentRange = "Not Needed";
        }
        else {
            var submitForPaymentDateChecks = _.get(this.topic.checksData, 'inbound.inbound.incentiveInformation.incentiveDetail.submitPaymentDate');
            var submitForPaymentDateGpp = _.get(this.topic.topic, 'gpp_valid[0].svi_submit_for_payment_date');
            var submitForPaymentDate = submitForPaymentDateChecks ? submitForPaymentDateChecks : submitForPaymentDateGpp;
            var submitForPaymentDateFormatted = submitForPaymentDate
                ? "Payment " + this.moment(Number(submitForPaymentDate)).format('YYYY-MM-DD')
                : "N/A";
            // probably it is so date
            var chargeAgreementStartDate = this.orderData.chargeAgreementStartDate;
            saasPaymentRange = submitForPaymentDateFormatted + " vs " + chargeAgreementStartDate;
        }
        rules.push({ n: 8, title: '30/60 Days Rule', model: 'saasPaymentRange', value: saasPaymentRange });
        rules.push({
            n: 9, title: 'Total Revenue vs Threshold', model: 'isThresholdValid', value: "" + this.orderData.totalRevenue
        });
        rules.push({ n: 10, title: 'Preferred Distributor', model: 'prefDistMatch', value: "" + (this.orderData.prefDist || 'Not Available') });
        rules.push({ n: 11, title: 'SaaS Coverage', model: 'coverageSaaS', value: this.orderData.coverageTerm });
        rules.push({ n: 12, title: 'Is Direct Order', model: 'isDirect', value: "" + (this.orderData.result.isDirect === true ? 'Yes' : 'No') });
        if (this.getNewUIInfo.uiVersion < this.OPP_VERSION_3) {
            rules.push({ n: 14, title: 'Was SaaS mixed with OnPrem', model: 'saasNotMixed', value: "" + (this.orderData.result.saasNotMixed ? 'No conflict' : 'Conflict found') });
        }
        rules.push({ n: 15, title: 'CMR Check', model: 'cmrCheck', value: "" + this.orderData.cnum });
        var applicability;
        if ((this.orderData.result.applicability === true || (this.orderData.result.applicability !== undefined && this.orderData.result.applicability.result === true))) {
            applicability = "Applicable for " + this.orderData.cnum;
        }
        else if (this.orderData.result.applicability && this.orderData.result.applicability.error) {
            applicability = "Failed to process Rule (hover for details) for " + this.orderData.cnum;
        }
        else {
            applicability = "Not Applicable for " + this.orderData.cnum;
        }
        rules.push({ n: 16, title: 'New Client Applicability', model: 'applicability', value: applicability });
        if (this.topic.checksData.isAutoEligibilityGoe) {
            rules.push({ n: 17, title: 'GOE Review', model: 'goeReview', value: this.orderData.result.goeReview });
        }
        // Getting rules applicable for this order
        this.orderRules = rules.filter(function (el) { return _this.orderData.result[el.model] !== undefined; });
    };
    DetailSOEvalController.prototype.setPnsRules = function (callbackFn) {
        var _this = this;
        var NOT_AVAILABLE = 'N/A';
        var sap = this.topic.topic.sap;
        var is4versionAndMore = this.getNewUIInfo.uiVersion >= this.OPP_VERSION_4;
        var solutionCheckSolIdKey = is4versionAndMore ? 'EI' : 'SOL';
        sap.forEach(function (pn, index) {
            var isNotPaid;
            if (pn.result.isNotPaid) {
                isNotPaid = "No Payment Detected";
            }
            else if (!pn.result.isNotPaid && pn.data.itemList[0].isPaidIn !== undefined) {
                isNotPaid = "Paid in " + pn.data.itemList[0].isPaidIn;
            }
            else if (!pn.result.isNotPaid && pn.data.itemList[0].isPaidIn === undefined) {
                isNotPaid = "Paid (Original ID not stored)";
            }
            var renewalStartDate = pn.data.itemList[0].renewalStartDate;
            // get rid of broken dates
            if (['00000000', '00/00/0000', '00.00.0000', 'RENWL_START_DATE'].includes(renewalStartDate)) {
                renewalStartDate = '';
            }
            else if (!(/\d{4}-\d{2}-\d{2}/.test(renewalStartDate))) {
                renewalStartDate = _this.moment(renewalStartDate, 'YYYYMMDD').format('YYYY-MM-DD');
            }
            //            const columnNameBFStatus: string = is4versionAndMore ? 'DRPG Status' : 'Checking Brand Family CVR Status';
            var rules = [];
            rules.push({ n: 1, title: 'Revenue Stream Code', model: 'revStreamCodeMatch', value: pn.data.itemList[0].revenueStreamCode });
            rules.push({ n: 2, title: 'Division Code', model: 'divisionCodeMatch', value: pn.data.itemList[0].divisionCode });
            var columnName9 = _this.getNewUIInfo.uiVersion >= _this.OPP_VERSION_3
                ? 'Engagement ID Comparison'
                : 'Solution ID Comparison';
            var engagementMappedCheck = _this.getMappedSolutionCheck(solutionCheckSolIdKey, pn.data.brandFamilyCode) || {};
            var solutionIdSapValue = _.get(pn, 'data.itemList[0].solutionId') || NOT_AVAILABLE; // null vaue can be here
            var eligibleSolutionIds;
            //checking 2 docs - 'checks_results/*_checks' & 'general/DMT-*'
            if (Array.isArray(engagementMappedCheck.solutions)) {
                eligibleSolutionIds = engagementMappedCheck.solutions.map(function (it) { return it.id; }).join(', ');
            }
            else if (Array.isArray(_this.solutionIdMap.get(pn.data.brandFamilyCode))) {
                eligibleSolutionIds = _this.solutionIdMap.get(pn.data.brandFamilyCode).join(', ');
            }
            if (!eligibleSolutionIds) {
                eligibleSolutionIds = NOT_AVAILABLE;
            }
            var engagementCheckValue = solutionIdSapValue === NOT_AVAILABLE && eligibleSolutionIds === NOT_AVAILABLE ? ''
                : solutionIdSapValue + " vs " + eligibleSolutionIds;
            //Brandcheck pass+EI approved in eligibility     ===> display EI comparison
            //Brandcheck pass+EI not approved in eligibility ===> do not display EI comparison
            //Brandcheck fail                                ===> display EI check with options to approve or not approve manually
            var allEiNotApproved = _this.topic.topic.version && _this.topic.topic.version >= _this.OPP_VERSION_5 ?
                _this.isAllEIEligibilityChecksNotApprovedV5() :
                _this.isAllEIEligibilityChecksNotApproved();
            var isEIAvailable = !allEiNotApproved && (!engagementMappedCheck.data || engagementMappedCheck.data === 'APPROVED');
            if (isEIAvailable) {
                var pnComments = pn.comments.pnEngagement;
                if (pnComments && pnComments.isFinal) {
                    if (pnComments.text) {
                        engagementCheckValue = pnComments.text;
                    }
                    if (Boolean(pnComments.text)) {
                        pn.result.solutionId = engagementCheckValue !== 'Not Approved' && pn.comments.pnEngagement.passFlag;
                    }
                }
                else {
                    if ((pnComments && !pnComments.isFinal) && pn.result.solutionId !== true) {
                        pn.result.solutionId = false;
                    }
                    else {
                        if (pnComments && _.isUndefined(pn.result.solutionId)) {
                        }
                        else {
                            if (_.isUndefined(pn.result.solutionId) && engagementMappedCheck.data === 'APPROVED') {
                                pn.result.solutionId = true;
                            }
                            if (eligibleSolutionIds === NOT_AVAILABLE || solutionIdSapValue === NOT_AVAILABLE) {
                                pn.result.solutionId = false;
                            }
                        }
                    }
                }
            }
            if (is4versionAndMore) {
                var pnComments = pn.comments.pnSalesInc;
                var checkValue = '';
                if (pnComments) {
                    checkValue = pnComments.text;
                    if (pnComments.isFinal && Boolean(checkValue)) {
                        pn.result.salesCheck = checkValue !== 'Not Approved' && pnComments.passFlag;
                    }
                    else {
                        if (!pnComments.isFinal && Boolean(checkValue)) {
                            pn.result.salesCheck = false;
                        }
                        else {
                            if (pnComments) {
                                checkValue = '';
                            }
                        }
                    }
                }
                if (_.isUndefined(pn.result.salesCheck)) {
                    pn.result.salesCheck = false;
                }
                rules.push({ n: 3, title: 'Sales Incentive', model: 'salesCheck', value: checkValue });
            }
            else {
                rules.push({
                    n: 3, title: 'Checking Brand Family CVR Status', model: 'bfstatusMatch', value: !pn.result.brandFound ? 'Brand Code Mismatch' : pn.data.x_svi_status
                });
            }
            rules.push({ n: 4, title: 'Global Brand Effective Date', model: 'GBTDate', value: _this.getGBTDateResult(pn) });
            rules.push({ n: 5, title: 'PPS brand check', model: 'ppBrandCheck', value: pn.data.ppBrand || 'Not Available' });
            rules.push({ n: 6, title: 'Payment Check', model: 'isNotPaid', value: isNotPaid });
            rules.push({ n: 7, title: 'Renewal Start Date Check', model: 'renewalStartDateCheck', value: renewalStartDate });
            rules.push({ n: 8, title: 'Continuous Billing Switch', model: 'continuousBillingSwitch', value: pn.data.itemList[0].renewalCode });
            if (isEIAvailable) {
                rules.push({ n: 9, title: columnName9, model: 'solutionId', value: engagementCheckValue });
            }
            if (is4versionAndMore) {
                //NOTE pn.result.<...> can be {result: false, infoOnly: true} - but it is writen by manual mode
                var pnComments = void 0;
                var checkValue = void 0;
                //GROWTH
                pnComments = pn.comments.pnGrowth;
                checkValue = '';
                if (pnComments) {
                    checkValue = pnComments.text;
                    //update only it is a manual mode
                    if (pnComments.isFinal && Boolean(checkValue)) {
                        pn.result.growthCheck = checkValue !== 'Not Approved' && pnComments.passFlag;
                    }
                    else {
                        if (!pnComments.isFinal && Boolean(checkValue)) {
                            pn.result.growthCheck = false;
                        }
                        else {
                            checkValue = '';
                        }
                    }
                }
                if (_.isUndefined(pn.result.growthCheck)) {
                    pn.result.growthCheck = false;
                }
                rules.push({ n: 10, title: 'SO Growth Check', model: 'growthCheck', value: checkValue });
                //FOCUS
                pnComments = pn.comments.pnFocus;
                checkValue = '';
                if (pnComments) {
                    checkValue = pnComments.text;
                    if (pnComments.isFinal && Boolean(checkValue)) {
                        pn.result.focusCheck = checkValue !== 'Not Approved' && pnComments.passFlag;
                    }
                    else {
                        if (!pnComments.isFinal && Boolean(checkValue)) {
                            pn.result.focusCheck = false;
                        }
                        else {
                            checkValue = '';
                        }
                    }
                }
                if (_.isUndefined(pn.result.focusCheck)) {
                    pn.result.focusCheck = false;
                }
                rules.push({ n: 11, title: 'SO Focus Check', model: 'focusCheck', value: checkValue });
                //CTL
                pnComments = pn.comments.pnCtl;
                checkValue = '';
                if (pnComments) {
                    checkValue = pnComments.text;
                    //update only it is a manual mode
                    if (pnComments.isFinal && Boolean(checkValue)) {
                        pn.result.ctlCheck = checkValue !== 'Not Approved' && pnComments.passFlag;
                    }
                    else {
                        if (!pnComments.isFinal && Boolean(checkValue)) {
                            pn.result.ctlCheck = false;
                        }
                        else {
                            checkValue = '';
                        }
                    }
                }
                if (_.isUndefined(pn.result.ctlCheck)) {
                    pn.result.ctlCheck = false;
                }
                rules.push({ n: 12, title: 'SO CTL Check', model: 'ctlCheck', value: checkValue });
            }
            var pnObj = _this.orderData.pns[index];
            if (is4versionAndMore) {
                _this.pnsRules[index] = rules.filter(function (el) {
                    var incentiveRules = [];
                    var mappedSolutionEICheck = _this.getMappedSolutionCheck(solutionCheckSolIdKey, pn.data.brandFamilyCode);
                    var isEINotApproved = mappedSolutionEICheck && mappedSolutionEICheck.data === 'NOT_APPROVED';
                    //hide 'Engagement ID Comparison' only when it is NOT approved in mapped solution EI checks
                    if (!isEINotApproved) {
                        incentiveRules.push('solutionId');
                    }
                    incentiveRules.push.apply(incentiveRules, ['growthCheck', 'focusCheck', 'ctlCheck']);
                    return pnObj.result[el.model] !== undefined || incentiveRules.includes(el.model);
                });
            }
            else {
                _this.pnsRules[index] = rules.filter(function (el) { return pnObj.result[el.model] !== undefined; });
            }
            // Getting rules applicable for this pn
        });
        if (callbackFn) {
            callbackFn();
        }
    };
    DetailSOEvalController.prototype.hasMappedSolutionCheck = function (pnIndex) {
        var solutionId = _.get(this.topic.topic, "sap[" + pnIndex + "].data.brandFamilyCode");
        var mappedSolutions = this.getMappedSolutions(solutionId);
        return Array.isArray(mappedSolutions) && mappedSolutions.length > 0;
    };
    DetailSOEvalController.prototype.isPnFailedAndEditable = function (pnIndex) {
        var res = !this.hasMappedSolutionCheck(pnIndex) || this.isNoCorrectIncentive(pnIndex) && this.checkIfPnFails(pnIndex);
        return res;
    };
    DetailSOEvalController.prototype.getMappedSolutions = function (solutionId) {
        return this.topic.topic.version && this.topic.topic.version >= this.OPP_VERSION_5
            ? this.getMappedSolutionsV5(solutionId)
            : this.getMappedSolutionsV3(solutionId);
    };
    DetailSOEvalController.prototype.getMappedSolutionsV3 = function (solutionId) {
        var mappedSolutions = _.get(this.topic, 'checksData.mappedResult.solutions');
        if (!solutionId || !Array.isArray(mappedSolutions)) {
            return [];
        }
        return mappedSolutions.filter(function (it) { return it.solutionId === solutionId && Boolean(it.checks); });
    };
    DetailSOEvalController.prototype.getMappedSolutionsV5 = function (drpgId) {
        var mappedSolutions = _.get(this.topic, 'checksData.mappedResult.dealRegs');
        if (!drpgId || !Array.isArray(mappedSolutions)) {
            return [];
        }
        return mappedSolutions.filter(function (it) { return it.dealRegistrationGroupId === drpgId && Boolean(it.checks); });
    };
    DetailSOEvalController.prototype.isAllEIEligibilityChecksNotApproved = function () {
        var mappedSolutions = _.get(this.topic, 'checksData.mappedResult.solutions', []);
        return mappedSolutions.every(function (solElem) {
            return _.get(solElem, "checks.EI.data", "NOT_APPROVED") === "NOT_APPROVED";
        });
    };
    DetailSOEvalController.prototype.isAllEIEligibilityChecksNotApprovedV5 = function () {
        var mappedSolutions = _.get(this.topic, 'checksData.mappedResult.dealRegs', []);
        if (!mappedSolutions || mappedSolutions.length === 0) {
            return false;
        }
        return mappedSolutions.every(function (solElem) {
            return _.get(solElem, "checks.EI.data", "NOT_APPROVED") === "NOT_APPROVED";
        });
    };
    DetailSOEvalController.prototype.getMappedSolutionCheck = function (mappedSolutionCheckId, solutionId) {
        var mappedSolutions = this.getMappedSolutions(solutionId);
        if (!Array.isArray(mappedSolutions) || mappedSolutions.length === 0) {
            return {};
        }
        return mappedSolutions.map(function (it) { return it.checks[mappedSolutionCheckId]; }).pop();
    };
    DetailSOEvalController.prototype.checkPnRules = function () {
        var _this = this;
        var pnObj;
        var hasAnyValidInc;
        this.pnsRules.forEach(function (pnRule, index) {
            pnObj = _this.orderData.pns[index];
            hasAnyValidInc = hasAnyValidIncentiveResult(pnObj);
            pnRule.forEach(function (rule) {
                var iconColor;
                var isIncRuleResolved = isIncResolved(rule.model, pnObj);
                var pnRuleResult = pnObj.result[rule.model];
                if (pnRuleResult === true || (typeof pnRuleResult === 'object' && pnRuleResult.result === true)) {
                    iconColor = IconColor.GREEN;
                }
                else if (pnRuleResult === false
                    || typeof pnRuleResult === 'undefined'
                    || (typeof pnRuleResult === 'object' && (pnRuleResult.result === false || pnRuleResult.infoOnly || pnRuleResult.passFlag))) {
                    if ((pnRuleResult === false || (typeof pnRuleResult === 'object' && pnRuleResult.infoOnly)) && hasAnyValidInc && isIncentive(rule.model)) {
                        iconColor = IconColor.ORANGE;
                    }
                    else if ((pnObj.comments[rule.model] || isIncRuleResolved) && pnObj.comments.pnOverall && pnObj.comments.pnOverall.passFlag) {
                        iconColor = IconColor.PINK;
                    }
                    else {
                        iconColor = IconColor.RED;
                    }
                }
                rule.iconColor = iconColor;
            });
        });
        this.checkSaas();
    };
    DetailSOEvalController.prototype.checkIfPnFails = function (pnIndex) {
        if (this.getNewUIInfo.uiVersion < this.OPP_VERSION_4) {
            //Just check if any rule is RED
            return this.pnsRules[pnIndex].filter(function (it) { return it.iconColor === IconColor.RED; }).length > 0;
        }
        // has an incentive AND no any valid incentive rule model
        // OR any non-inventive rule model is RED
        return hasAllIncentivesFailed(this.pnsRules[pnIndex]) || hasNonIncentiveRuleFailed(this.pnsRules[pnIndex]);
    };
    DetailSOEvalController.prototype.isNoCorrectIncentive = function (pnIndex) {
        return this.getNewUIInfo.uiVersion < this.OPP_VERSION_4 || !hasAllIncentivesFailed(this.pnsRules[pnIndex]);
    };
    DetailSOEvalController.prototype.checkIfPnRuleFails = function (pnIndex, pnRuleIndex) {
        if (this.getNewUIInfo.uiVersion < this.OPP_VERSION_4) {
            //Just check if any rule is RED
            return this.pnsRules[pnIndex][pnRuleIndex].iconColor === IconColor.RED;
        }
        // has an incentive AND no any valid incentive rule model
        // OR any non-inventive rule model is RED
        return hasAllIncentivesFailed(this.pnsRules[pnIndex]) || hasNonIncentiveRuleFailed(this.pnsRules[pnIndex]);
    };
    DetailSOEvalController.prototype.checkOrderRuleFailed = function () {
        for (var _i = 0, _a = this.orderRules; _i < _a.length; _i++) {
            var rule = _a[_i];
            if (this.orderData.comments[rule.model] && this.orderData.comments[rule.model].isFinal && !this.orderData.comments[rule.model].passFlag) {
                return true;
            }
        }
        return false;
    };
    DetailSOEvalController.prototype.isManualMode = function (ruleModel, pn, pnIndex, pnRuleIndex) {
        var ruleModulId = ruleModel && pn && pn.comments && pn.result
            && this.checkIfPnRuleFails(pnIndex, pnRuleIndex)
            ? ruleModel : '';
        switch (ruleModulId) {
            case 'solutionId':
                return this.getNewUIInfo.uiVersion >= this.OPP_VERSION_4
                    && !this.isFinalCommentTrue(pn.comments.pnEngagement)
                    && !this.hasMappedSolutionCheck(pnIndex)
                    && !pn.result.solutionId;
            case 'growthCheck':
                return !this.isFinalCommentTrue(pn.comments.pnGrowth)
                    && !this.hasMappedSolutionCheck(pnIndex)
                    && !pn.result.growthCheck;
            case 'focusCheck':
                return !this.isFinalCommentTrue(pn.comments.pnFocus)
                    && !this.hasMappedSolutionCheck(pnIndex)
                    && !pn.result.focusCheck;
            case 'salesCheck':
                return !this.isFinalCommentTrue(pn.comments.pnSalesInc)
                    && !this.hasMappedSolutionCheck(pnIndex)
                    && !pn.result.salesCheck;
            case 'ctlCheck':
                return !this.isFinalCommentTrue(pn.comments.pnCtl)
                    && !this.hasMappedSolutionCheck(pnIndex)
                    && !pn.result.ctlCheck;
            default:
                return false;
        }
    };
    DetailSOEvalController.prototype.isFinalCommentTrue = function (pnCommentObject) {
        return pnCommentObject && pnCommentObject.isFinal;
    };
    DetailSOEvalController.prototype.getManualModeModel = function (ruleModel, pn) {
        switch (ruleModel) {
            case 'solutionId':
                return this.pnsEngagementComments[pn.data.itemList[0].pn];
            case 'growthCheck':
                return this.pnsGrowthComments[pn.data.itemList[0].pn];
            case 'focusCheck':
                return this.pnsFocusComments[pn.data.itemList[0].pn];
            case 'salesCheck':
                return this.pnsSalesIncComments[pn.data.itemList[0].pn];
            case 'ctlCheck':
                return this.pnsCtlComments[pn.data.itemList[0].pn];
            default:
                return undefined;
        }
    };
    DetailSOEvalController.prototype.setOrderResult = function (pns) {
        var _this = this;
        var result = {};
        pns.forEach(function (pn) {
            _this.orderRulesNames.forEach(function (rule) {
                var ruleValue = pn.result[rule];
                if (ruleValue !== undefined && ((result[rule] === undefined) || (result[rule] === false && ruleValue))) {
                    result[rule] = ruleValue;
                }
            });
        });
        return result;
    };
    /**
     * Function to render the Global Brand Effective Date (rule #12) results correctly
     * @param soData
     */
    DetailSOEvalController.prototype.getGBTDateResult = function (so) {
        if (!so.result.brandFound) {
            return 'Brand Code Mismatch';
        }
        else if (so.data.noSVISubmitDate) {
            // The above field will be set during Validation if not SVI Submit Date could be found when it came to compare
            // GBT entry with svi date
            return 'No Opportunity Submit Date';
        }
        else {
            var sd = this.$filter('date')(new Date(so.data.brandFamilyEffDate * 1000), 'yyyy-MM-dd');
            var ed = this.$filter('date')(new Date(so.data.brandFamilyEndDate * 1000), 'yyyy-MM-dd');
            return sd + " vs " + ed + " ";
        }
    };
    DetailSOEvalController.prototype.setBrandArray = function () {
        this.rowIdArr = [];
        this.brandfamArr = [];
        this.solutionIdMap = new Map();
        // assume oneGPP.row_id are unique, used as solution map keys
        var _loop_1 = function(oneGPP) {
            if (this_1.topic.checksData.uiVersion >= this_1.OPP_VERSION_3) {
                if (this_1.topic.checksData) {
                    // in top level of the objects from 'data' array there is 'solutionId' (correct field name would be drpgId) and
                    // array 'solutions' (correct name in this case) that contains actual solution ids
                    // get solutions from the arrays with the according drpgId 
                    // (primary key includes gbt20, but we merge solutions for all different gbt20 values) to map them to sap
                    var solutionObjects = _.get(this_1.topic.checksData, 'result.SOL.data');
                    if (Array.isArray(solutionObjects)) {
                        // filter by drpg id (solutionId = drpgId, bad naming)
                        var filteredSolutionObjects = solutionObjects.filter(function (solObj) { return solObj.solutionId === oneGPP.row_id; });
                        if (Array.isArray(filteredSolutionObjects)) {
                            // create set, if solution ids are not unique
                            var drpgSolutionIds_1 = new Set();
                            filteredSolutionObjects.forEach(function (solObj) {
                                if (solObj && solObj.solutions) {
                                    // get solution id values from arrays and put to the set
                                    solObj.solutions.map(function (sol) { return sol.id; }).forEach(drpgSolutionIds_1.add, drpgSolutionIds_1);
                                }
                            });
                            // result mapping drpg - solution ids array
                            this_1.solutionIdMap.set(oneGPP.row_id, Array.from(drpgSolutionIds_1));
                        }
                    }
                }
                this_1.brandfamArr.push(oneGPP.row_id);
            }
            else {
                this_1.brandfamArr.push(oneGPP.brandcode);
                var solIds = [];
                if (oneGPP.solutionId &&
                    oneGPP.solutionId !== null &&
                    oneGPP.solutionId.trim() !== '') {
                    solIds = oneGPP.solutionId.split('\n');
                }
                this_1.solutionIdMap.set(oneGPP.brandcode, solIds);
            }
            this_1.rowIdArr.push(oneGPP.row_id);
        };
        var this_1 = this;
        for (var _i = 0, _a = this.topic.topic.gpp_valid; _i < _a.length; _i++) {
            var oneGPP = _a[_i];
            _loop_1(oneGPP);
        }
    };
    DetailSOEvalController.prototype.isPnPassed = function (pn, index) {
        var pnNumber = pn.data.itemList[0].pn;
        // case, when decision to pass pn was taken
        if (pn.comments.pnOverall && pn.comments.pnOverall.passFlag) {
            return true;
        }
        // case, when autofail took place or decision to fail pn
        if ((pn.comments.pnAutofail && !pn.comments.pnAutofail.passFlag) || (pn.comments.pnOverall && !pn.comments.pnOverall.passFlag)) {
            return false;
        }
        // otherwise look at pn rules
        return !this.checkIfPnFails(index);
    };
    DetailSOEvalController.prototype.checkValidationComplete = function () {
        var _this = this;
        if (this.topic.topic.complete.statusComplete['4']) {
            return true;
        }
        else {
            // If calculation node is present, validation has been completed
            if (this.topic.topic.calculation && this.topic.topic.complete.calculation && this.topic.topic.complete.complcl_calculation) {
                return true;
            }
            else {
                // check if all validation sections are completed
                var validThumbSections = ['sap', 'goePick_valid', 'goeCheck_valid', 'complcl_validation',
                    'complcl_calculation', 'calculation'];
                var isValidCompleted = validThumbSections.filter(function (secName) { return !_this.topic.topic.complete[secName]; }).length === 0;
                return isValidCompleted;
            }
        }
        return false;
    };
    /**
     * Disabling button based on logic
     * @private
     * @param {string} name
     * @param {(number | string)} additionalInfo
     * @returns {boolean}
     * @memberof DetailSOEvalController
     */
    DetailSOEvalController.prototype.isButtonDisabled = function (name, additionalInfo) {
        var _this = this;
        var model, index;
        if (typeof additionalInfo === 'string') {
            model = additionalInfo;
        }
        if (typeof additionalInfo === 'number') {
            index = additionalInfo;
        }
        var buttonName = {
            'triggerCalculations': function () { return (_this.topic.editableComponents.sap.socket ||
                !_this.checkValidationComplete()
                || _this.topic.topic && _this.topic.topic.errors && _this.topic.topic.errors.unresolved > 0
                || !_this.get2GoeValidCondition()); },
            'soDecision': function () { return (_this.topic.editableComponents.sap.socket ||
                !_this.orderData.comments[model]
                || _this.orderData.comments[model].text.trim() === ''); },
            'soAutoFail': function () { return _this.orderData.pns[0].comments.soAutofail || _this.topic.editableComponents.sap.socket; },
            'pnDecision': function () {
                return _this.isPnDecisionDesbl(index);
            },
            'pnAutoFail': function () { return _this.topic.editableComponents.sap.socket; }
        };
        return this.isUpdating || buttonName[name]();
    };
    DetailSOEvalController.prototype.isPnDecisionDesbl = function (index) {
        var _this = this;
        var focus = false, growth = false, ctl = false;
        var pns = !this.pnsComments || !this.pnsComments[index] || !this.pnsComments[index].trim();
        if (this.getNewUIInfo.uiVersion >= this.OPP_VERSION_4) {
            this.topic.topic.sap.forEach(function (elem, i) {
                if (i === index) {
                    var bf = elem.data.itemList[0].pn;
                    ctl = !elem.result.ctlCheck && !(_.isUndefined(elem.result.ctlCheck)) &&
                        (!_this.pnsCtlComments || !_this.pnsCtlComments[bf] || !_this.pnsCtlComments[bf].trim());
                    focus = !elem.result.focusCheck && !(_.isUndefined(elem.result.focusCheck)) &&
                        (!_this.pnsFocusComments || !_this.pnsFocusComments[bf] || !_this.pnsFocusComments[bf].trim());
                    growth = !elem.result.growthCheck && !(_.isUndefined(elem.result.growthCheck)) &&
                        (!_this.pnsGrowthComments || !_this.pnsGrowthComments[bf] || !_this.pnsGrowthComments[bf].trim());
                    _this.pnsCtlComments[index] = !elem.result.ctlCheck ? _this.pnsCtlComments[bf] : '';
                    _this.pnsFocusComments[index] = !elem.result.focusCheck ? _this.pnsFocusComments[bf] : '';
                    _this.pnsGrowthComments[index] = !elem.result.growthCheck ? _this.pnsGrowthComments[bf] : '';
                    _this.pnsSalesIncComments[index] = !elem.result.salesCheck ? _this.pnsSalesIncComments[bf] : '';
                    _this.pnsEngagementComments[index] = !elem.result.solutionId ? _this.pnsEngagementComments[bf] : '';
                }
            });
        }
        return pns || focus || growth || ctl || this.topic.editableComponents.sap.socket;
    };
    DetailSOEvalController.prototype.get2GoeValidCondition = function () {
        return _.get(this.topic.topic, 'complete.goeCheck_valid');
    };
    DetailSOEvalController.prototype.isManualSearchExists = function () {
        var cmrValidResults = _.get(this.topic.topic, 'cmr_valid.results', []);
        for (var _i = 0, cmrValidResults_1 = cmrValidResults; _i < cmrValidResults_1.length; _i++) {
            var result = cmrValidResults_1[_i];
            if (result.user && result.user !== 'system' && result.user !== 'dmt') {
                return true;
            }
        }
        var goeValidResults = _.get(this.topic.topic, 'goe_valid.results', []);
        for (var _a = 0, goeValidResults_1 = goeValidResults; _a < goeValidResults_1.length; _a++) {
            var result = goeValidResults_1[_a];
            if (result.user && result.user !== 'system' && result.user !== 'dmt') {
                return true;
            }
        }
        return false;
    };
    DetailSOEvalController.prototype.isAttachmentExists = function () {
        var files = this.topic.topic.files;
        if (!files) {
            return false;
        }
        for (var _i = 0, files_1 = files; _i < files_1.length; _i++) {
            var file = files_1[_i];
            if (file.type === 'fcmr_valid') {
                return true;
            }
        }
        return false;
    };
    DetailSOEvalController.$inject = ['topic', '$stateParams', 'settings', 'env', 'socket', '$scope', 'Dialog', '$state', '$filter', 'moment'];
    return DetailSOEvalController;
}());
var DetailSOEComponent = (function () {
    function DetailSOEComponent() {
        this.templateUrl = 'detail-validation-sales-orders-eval.html';
        this.controllerAs = 'vm';
        this.controller = DetailSOEvalController;
    }
    return DetailSOEComponent;
}());
angular
    .module('application')
    .config(function ($mdIconProvider) {
    $mdIconProvider
        .icon('delete', '/public/icons/delete-forever.svg')
        .icon('reevaluate', '/public/icons/ic_compare_arrows_black_24px.svg');
})
    .component('detailValidationSalesOrdersEval', new DetailSOEComponent());

//# sourceMappingURL=detail.validation.sales-orders-eval.component.js.map
